import 'prop-types';
import Sentry from '@dbh/sentry';
import '@dbh/generic-types';
import throwInServerSideRendering from '@dbh/throw-in-server-side-rendering';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

/*
 *
 * `easeInOutSin`: `@dbh/animate-scroll`.
 *
 */const easeInOutSin=a=>(1+Math.sin(Math.PI*a-Math.PI/2))/2;var easeInOutSin$1 = easeInOutSin;

const DEFAULT_ANIMATE_OPTIONS={ease:easeInOutSin$1,duration:300};const DEFAULT_ANIMATE_PAYLOAD=Object.freeze({cancelled:!1,duration:0});

/**
 * @typedef {import('./types').AnimatePromiseAndCancel} AnimatePromiseAndCancel
 *//**
 * Animates a property of an `Object` interpolating from the current value of
 * `element[prop]` to the value of `to` argument.
 * This function mutates `element`.
 * Primarely meant to be used with `HTMLElement` style properties but it can
 * be used to animate `canvas` or more.
 * @param {string} prop The `HTMLElement` property to animate @example 'scrollTop'.
 * @param {HtmlElement} element @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement}.
 * @param {number} to The final value of `element[prop]`.
 * @param {Object?} options .
 * @param {number} options.duration Should be > 0.
 * @param {Function} ease Will determine the animation easing.
 * @return {AnimatePromiseAndCancel} .
 * @example
 * ```js
 *   // Scrolls window from its original position to 2000 in 250ms.
 *   animate('scrollTop', document.documentElement, 2000, { duration: 250 });
 * ```
 */const animate=withConformsTo("animate",[],(a,b,c,d)=>{throwInServerSideRendering("animate");let e=!1;const f=new Promise(f=>{const g=b[a];let h=null;const{ease:i,duration:j}={...DEFAULT_ANIMATE_OPTIONS,...d},k=d=>{var l=Math.min;e&&f({cancelled:!0,duration:d-h}),null===h&&(h=d);// `time` is in range `[0; 1]`, when `time >= 1 the
// animation is completed.
const m=l(1,(d-h)/j);// eslint-disable-next-line no-param-reassign
b[a]=i(m)*(c-g)+g,1<=m?f({cancelled:!1,duration:d-h}):window.requestAnimationFrame(k);};g===c?f(DEFAULT_ANIMATE_PAYLOAD):window.requestAnimationFrame(k);});return f.catch(a=>{Sentry.captureException(a);}),[f,()=>{e=!0;}]});var animate$1 = animate;

/**
 * @typedef {import('./types').AnimatePromiseAndCancel} AnimatePromiseAndCancel
 *//**
 * Cross browser compatible animated scroll.
 * @param {HTMLElement} element @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement}.
 * @param {number?} to Scroll value.
 * @param {boolean?} horizontal Should scroll horizontal otherwise vertical.
 * @param {Object?} animateOptions Will be passed to `animate()`.
 * @see {@link https://gist.github.com/andjosh/6764939}
 * @return {AnimatePromiseAndCancel} .
 */const animateScroll=function(a,b,c,d){if(void 0===c&&(c=!0),!a)return null;const e=c?"scrollLeft":"scrollTop";return animate$1(e,a,b,d)};var animateScroll$1 = animateScroll;

/*
 *
 * `easeInOutQuad`: `@dbh/animate-scroll`.
 *
 */const easeInOutQuad=a=>.5>a?2*a*a:-1+(4-2*a)*a;var easeInOutQuad$1 = easeInOutQuad;

export { DEFAULT_ANIMATE_OPTIONS, DEFAULT_ANIMATE_PAYLOAD, animateScroll$1 as default, easeInOutQuad$1 as easeInOutQuad, easeInOutSin$1 as easeInOutSin };
